export const getUsers = `query {
    kbUsersWithRoles{
        users {
          firstName
          lastName
          email
          role
          ocplcRole
          roles{
            name
            id
          }
        }
        roles{
          id
          name
        }
      }
}`
